import { TrickFormHookGroupedTrainFormSchema } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { FormFieldWithCustomInput } from "features/CenterContent/shared/operationalInformation/components/FormFieldWithCustomInput";
import {
  EventType,
  GenericType,
} from "features/CenterContent/shared/operationalInformation/hooks/useOperationalInformationTypes";
import { FC, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getTrainCustomInputs } from "shared/types/form";

export type BatchCommonInputProps = {
  pathPrefix: `\${groupKey}`;
  numberOfGroups: number;
};

type CustomInputProps = {
  items: GenericType[] | EventType[];
  formFieldType: "event" | "reason" | "action";
};

export const BatchTrainFormFieldWithCustomInput: FC<
  CustomInputProps & BatchCommonInputProps
> = ({ pathPrefix, numberOfGroups, items, formFieldType }) => {
  const { t } = useTranslation();

  const customInputs = getTrainCustomInputs(t)[formFieldType];
  const customInputsWithOptional = {
    severityFormField: undefined,
    ...customInputs,
  };
  const { label, typeFormField, customFormField, severityFormField } =
    customInputsWithOptional;

  const { watch, setValue } =
    useFormContext<TrickFormHookGroupedTrainFormSchema>();

  // All groups in a train series have the same value for these fields,
  // Use the values from the first group to display in modal
  const displayTypeFormField = `${pathPrefix}.0.${typeFormField}` as const;
  const displayCustomFormField = `${pathPrefix}.0.${customFormField}` as const;
  const displaySeverityFormField = severityFormField
    ? (`${pathPrefix}.0.${severityFormField}` as const)
    : undefined;

  const displayTypeForm = watch(displayTypeFormField);
  const displayCustomForm = watch(displayCustomFormField);
  const displaySeverityForm = displaySeverityFormField
    ? watch(displaySeverityFormField)
    : undefined;

  useEffect(() => {
    // Update the other groups if typeForm or customForm changes
    for (let n = 1; n < numberOfGroups; n += 1) {
      const groupTypeFormField = `${pathPrefix}.${n}.${typeFormField}` as const;
      const groupCustomFormField =
        `${pathPrefix}.${n}.${customFormField}` as const;
      setValue(groupTypeFormField, displayTypeForm);
      setValue(groupCustomFormField, displayCustomForm);
      if (severityFormField && displaySeverityForm) {
        const groupSeverityFormField =
          `${pathPrefix}.${n}.${severityFormField}` as const;
        setValue(groupSeverityFormField, displaySeverityForm);
      }
    }
  }, [displayTypeForm, displayCustomForm, displaySeverityForm]);

  return (
    <FormFieldWithCustomInput
      items={items}
      label={label}
      typeFormField={displayTypeFormField}
      customFormField={displayCustomFormField}
      severityFormField={displaySeverityFormField}
    />
  );
};
